import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
import { List, MagnifyingGlass } from "@phosphor-icons/react";
import AdminNavbarLinks from "./AdminNavbarLinks.js";
import { useRouteName } from "hooks";

const useStyles = makeStyles({
  appBar: {
    backgroundColor: "#ffffff",
    boxShadow: "0 16px 36px rgba(15, 23, 42, 0.06)",
    position: "absolute",
    width: "calc(100% - 32px)",
    zIndex: 1029,
    minHeight: "66px",
    display: "block",
    border: "none",
    borderRadius: "0 0 18px 18px",
    margin: "0 16px",
  },
  toolbar: {
    minHeight: "66px",
    paddingLeft: "22px",
    paddingRight: "22px",
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  flex: { flex: 1 },
  breadcrumb: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13px",
    color: "#718096",
  },
  routeName: {
    fontSize: "17px",
    fontWeight: "800",
    color: "#0f172a",
    fontFamily: '"Inter", "Roboto", sans-serif',
  },
  searchBox: {
    display: "flex",
    alignItems: "center",
    background: "#f7f9fc",
    borderRadius: "10px",
    padding: "8px 12px",
    gap: "10px",
    width: "320px",
    border: "1px solid transparent",
    transition: "all 0.2s",
    "&:focus-within": {
      background: "#fff",
      border: "1px solid #2f72f2",
    },
  },
  searchInput: {
    border: "none",
    background: "transparent",
    outline: "none",
    fontSize: "13px",
    color: "#4a5568",
    width: "100%",
    fontFamily: '"Inter", "Roboto", sans-serif',
  },
});

export default function Navbar(props) {
  const classes = useStyles();
  const routeName = useRouteName();

  return (
    <AppBar className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <div className={classes.flex}>
          <div className={classes.breadcrumb}>
            <span style={{ color: "#a0aec0" }}>Admin</span>
            <span style={{ color: "#d1d5db" }}>/</span>
            <span className={classes.routeName}>{routeName}</span>
          </div>
        </div>

        <Hidden smDown implementation="css">
          <div className={classes.searchBox}>
            <MagnifyingGlass size={16} weight="bold" color="#94a3b8" />
            <input className={classes.searchInput} placeholder="Search" />
          </div>
          <AdminNavbarLinks setLoggedin={props.setLoggedin} />
        </Hidden>

        <Hidden mdUp implementation="css">
          <IconButton color="inherit" onClick={props.handleDrawerToggle}>
            <List size={24} weight="bold" color="#4a5568" />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

Navbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
  setLoggedin: PropTypes.any,
};
